// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__1VZMO","search":"Settings_search__1Wn-d","filter":"Settings_filter__M-Thc"};